// extracted by mini-css-extract-plugin
export default {"path":"Share_path__sFzu2","heading":"Share_heading__sWAhP","label":"Share_label__BOZs-","copy_container":"Share_copy_container__YI1Oa"};